import React from "react";
import { Link } from "react-router-dom";

const CompanyContactSection = () => {
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL || "";
    // আপনার লোগো বা প্রয়োজনীয় ইমেজ পাথ
    const logoImg = "90.png"; // অথবা ডাইনামিক লোগো পাথ দিতে পারেন

    return (
        <section className="py-5" style={{ backgroundColor: '#ffffff' }}>
            <div className="container py-4">
                {/* Header & Subtitle */}
                <div className="row mb-5">
                    <div className="col-lg-8">
                        <div className="mb-2">
                            <span
                                className="badge px-3 py-2 fw-normal text-uppercase"
                                style={{
                                    backgroundColor: '#eff6ff',
                                    border: '1px solid #bfdbfe',
                                    borderRadius: '30px',
                                    fontSize: '12px',
                                    letterSpacing: '1px',
                                    color: '#2563eb'
                                }}
                            >
                                Contact & Partnership
                            </span>
                        </div>
                        <h2 className="display-6 fw-bold text-dark mt-2 mb-2">
                            Build Your Future Workforce With Us
                        </h2>
                        <p className="text-muted small">
                            Tarif Overseas Limited – Your Reliable Partner in Human Resources
                        </p>
                    </div>
                </div>

                {/* Main Content Row */}
                <div className="row align-items-center g-5">
                    {/* Left Side: Logo & Agency Info */}
                    <div className="col-lg-6 text-center text-lg-start">
                        <div className="p-4 d-inline-block">
                            <div className="mb-3 d-flex justify-content-center justify-content-lg-start">
                                <img
                                    src={logoImg}
                                    alt="Tarif Overseas Logo"
                                    className="img-fluid"
                                    style={{ objectFit: 'contain' }}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Right Side: Contact Info Card */}
                    <div className="col-lg-6">
                        <div
                            className="card border-0 p-4 p-md-5 shadow-sm rounded-4"
                            style={{
                                backgroundColor: '#f8fafc',
                                border: '1px solid rgba(0, 0, 0, 0.05)',
                                transition: 'all 0.3s ease'
                            }}
                        >
                            <h4 className="fw-bold text-dark mb-4">Tarif Overseas Ltd.</h4>

                            <ul className="list-unstyled mb-0 d-flex flex-column gap-3">
                                <li className="d-flex align-items-center">
                                    <div className="icon-box text-primary me-3 fs-5">
                                        <i className="fa fa-phone-alt"></i>
                                    </div>
                                    <div>
                                        <span className="text-muted d-block small">Phone</span>
                                        <a href="tel:+8801798733185" className="text-dark text-decoration-none fw-semibold">
                                            +8801798 733185
                                        </a>
                                    </div>
                                </li>

                                <li className="d-flex align-items-center">
                                    <div className="icon-box text-primary me-3 fs-5">
                                        <i className="fa fa-envelope"></i>
                                    </div>
                                    <div>
                                        <span className="text-muted d-block small">Email</span>
                                        <a href="mailto:ceo.tarifoverseas@gmail.com" className="text-dark text-decoration-none fw-semibold">
                                            ceo.tarifoverseas@gmail.com
                                        </a>
                                    </div>
                                </li>

                                <li className="d-flex align-items-center">
                                    <div className="icon-box text-primary me-3 fs-5">
                                        <i className="fa fa-globe"></i>
                                    </div>
                                    <div>
                                        <span className="text-muted d-block small">Website</span>
                                        <a href="https://www.tarifoverseasltd.com" target="_blank" rel="noreferrer" className="text-dark text-decoration-none fw-semibold">
                                            www.tarifoverseasltd.com
                                        </a>
                                    </div>
                                </li>

                                <li className="d-flex align-items-center">
                                    <div className="icon-box text-primary me-3 fs-5">
                                        <i className="fa fa-map-marker-alt"></i>
                                    </div>
                                    <div>
                                        <span className="text-muted d-block small">Address</span>
                                        <span className="text-dark fw-semibold">
                                            Dhaka, Bangladesh
                                        </span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CompanyContactSection;